import React, { useEffect, useRef } from 'react';
import ReactQuill from 'react-quill';

import 'react-quill/dist/quill.snow.css';
import 'quill/dist/quill.snow.css';
import './styles.css';

interface Props {
  initialContent?: string;
  readOnly?: boolean;
  onChange?: (value: string) => void;
  errorMsg?: string;
  placeholder?: string;
  value?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  quillRef?: any;
}

export const RichEditor = ({
  initialContent,
  readOnly,
  onChange,
  errorMsg,
  placeholder,
  value,
  quillRef,
}: Props) => {
  const ref = useRef(null);

  useEffect(() => {
    if (quillRef) {
      quillRef.current = ref.current;
    }
  }, [quillRef]);

  return (
    <div>
      <ReactQuill
        theme={readOnly ? 'bubble' : 'snow'}
        readOnly={readOnly}
        defaultValue={initialContent}
        onChange={onChange}
        style={{
          height: '50vh',
        }}
        value={value}
        modules={RichEditor.modules}
        formats={RichEditor.formats}
        placeholder={placeholder}
        ref={ref}
      />

      {errorMsg ? <div>{errorMsg}</div> : null}
    </div>
  );
};

RichEditor.modules = {
  toolbar: [
    [{ header: '1' }, { header: '2' }],
    [{ size: ['small', false, 'large', 'huge'] }],
    ['bold', 'italic', 'underline', 'strike', 'blockquote'],
    [
      { list: 'ordered' },
      { list: 'bullet' },
      { indent: '-1' },
      { indent: '+1' },
    ],
    [{ align: [] }],
    ['link', 'image'],
    ['clean'],
  ],
};

RichEditor.formats = [
  'header',
  'size',
  'bold',
  'italic',
  'underline',
  'align',
  'strike',
  'script',
  'blockquote',
  'background',
  'list',
  'bullet',
  'indent',
  'color',
  'code-block',
  'image',
];
